import { humanizeOptionLabel, parseOptions, patchCompany } from "../../cs_edit";

type CustomersSelectInlineEditConfig = {
  selector: string;
  eventNamespace: string;
  optionsAttr: string;
  payloadField: string;
  parseErrorMessage: string;
};

export function initCustomersSelectInlineEdit(
  config: CustomersSelectInlineEditConfig,
) {
  $(config.selector)
    .off(config.eventNamespace)
    .on(config.eventNamespace, function (e) {
      e.stopPropagation();
      if ($(this).find(".inline-edit-select").length) return;

      const currentValue = $(this).attr("data-sort-value") || "";
      const currentTextValue = ($(this).text() || "").trim().toLowerCase();
      const optionsRaw = $(this).attr(config.optionsAttr) || "[]";
      const options = parseOptions(optionsRaw, config.parseErrorMessage);

      let selectedValue = currentValue;
      for (let i = 0; i < options.length; i += 1) {
        const optionValue = options[i];
        const humanizedOptionValue = humanizeOptionLabel(optionValue);
        if (
          optionValue === currentValue ||
          humanizedOptionValue === currentValue ||
          humanizedOptionValue.toLowerCase() === currentTextValue
        ) {
          selectedValue = optionValue;
          break;
        }
      }

      const id = $(this).closest(".customer-row").attr("data-id");
      const csDatumId = $(this)
        .closest(".customer-row")
        .attr("data-cs-datum-id");
      if (!id) return;

      const originalHTML = $(this).html();
      const select = document.createElement("select");
      select.className = "inline-edit-select";

      options.forEach((optionValue) => {
        const option = document.createElement("option");
        option.value = optionValue;
        option.textContent = humanizeOptionLabel(optionValue);
        if (optionValue === selectedValue) {
          option.selected = true;
        }
        select.appendChild(option);
      });

      $(this).text("");
      $(this).addClass("is-editing");
      $(this).append(select);
      select.focus();

      let saved = false;
      const cell = this as HTMLElement;

      const save = () => {
        if (saved) return;
        saved = true;

        const newValue = select.value;
        if (newValue === selectedValue) {
          cancel();
          return;
        }

        $(cell).removeClass("is-editing");
        $(cell).text("Saving...");
        $(cell).addClass("inline-edit-saving");

        const csDatumAttributes: { [key: string]: string } = {};
        csDatumAttributes[config.payloadField] = newValue;

        if (csDatumId) {
          csDatumAttributes.id = csDatumId;
        }

        patchCompany(
          id,
          { cs_datum_attributes: csDatumAttributes },
          cell,
          originalHTML,
        );
      };

      const cancel = () => {
        if (saved) return;
        saved = true;
        $(cell).removeClass("is-editing");
        $(cell).html(originalHTML);
      };

      select.onkeydown = (event) => {
        if (event.key === "Escape") {
          event.preventDefault();
          cancel();
        }
      };
      select.onchange = save;
      select.onblur = cancel;
    });
}
